import angular from 'angular';
import clientLookup from './clientLookup';

export default angular
  .module('commission.components.clientLookup', [])
  .component('clientLookup', clientLookup).name;
